import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { ConfirmPolyPlanningLevelDialogContent } from './ConfirmPolyPlanningLevelDialogContent'

interface IProps {
  isShowDialog: boolean
  newPolyPlanningLevel: string
  onConfirm: () => void
  onClose: () => void
}

export const ConfirmPolyPlanningLevelDialog = ({
  isShowDialog,
  newPolyPlanningLevel,
  onConfirm,
  onClose,
}: IProps) => {
  const contentProps = useMemo(() => {
    return { newPolyPlanningLevel, onConfirm, onClose }
  }, [newPolyPlanningLevel, onConfirm, onClose])

  return (
    <ModalDialog
      size={'xs'}
      show={isShowDialog}
      content={ConfirmPolyPlanningLevelDialogContent}
      contentProps={contentProps}
      onClose={onClose}
    />
  )
}
